export const TOTAL_HORSES = 20
export const HORSES_PER_RACE = 10
export const MIN_CONDITION = 1
export const MAX_CONDITION = 100

export const TOTAL_ROUNDS = 6
export const ROUND_DISTANCES = [1200, 1400, 1600, 1800, 2000, 2200]

export const BASE_RACE_DURATION = 10000
export const ANIMATION_FRAME_RATE = 60

// Race time calculation constants
export const BASE_TIME_MULTIPLIER = 5
export const CONDITION_DIVISOR = 200
export const RANDOM_FACTOR_MIN = 0.9
export const RANDOM_FACTOR_RANGE = 0.2

export const HORSE_NAMES = [
  'Thunder', 'Lightning', 'Storm', 'Shadow',
  'Blaze', 'Spirit', 'Rocket', 'Arrow',
  'Bullet', 'Comet', 'Flash', 'Tornado',
  'Cyclone', 'Viper', 'Phantom', 'Ghoust',
  'Mavrick', 'Rebel', 'Ace', 'Duke'
]

export const HORSE_COLORS = [
  { name: 'Red', hex: '#e53935' },
  { name: 'Blue', hex: '#1e88e5' },
  { name: 'Yellow', hex: '#fdd835' },
  { name: 'Green', hex: '#43a047' },
  { name: 'Purple', hex: '#8e24aa' },
  { name: 'Orange', hex: '#fb8c00' },
  { name: 'Pink', hex: '#d81b60' },
  { name: 'Teal', hex: '#00897b' },
  { name: 'Indigo', hex: '#3949ab' },
  { name: 'Brown', hex: '#6d4c41' },
  { name: 'Cyan', hex: '#00acc1' },
  { name: 'Lime', hex: '#7cb342' },
  { name: 'Amber', hex: '#ffb300' },
  { name: 'DarkPurple', hex: '#5e35b1' },
  { name: 'LightBlue', hex: '#039be5' },
  { name: 'DarkOrange', hex: '#f4511e' },
  { name: 'Grey', hex: '#757575' },
  { name: 'BlueGrey', hex: '#546e7a' },
  { name: 'Coral', hex: '#ff7043' },
  { name: 'Magneta', hex: '#ab47bc' }
]

export const RACE_STATUS = {
  IDLE: 'idle',
  READY: 'ready',
  RUNNING: 'running',
  PAUSED: 'paused',
  FINISHED: 'finished'
}
